import { EntityActionConfirmDialogProps } from '../../../entity-actions/interfaces/entity-actions';
import { Destination, DestinationAction } from '../../../shared/interfaces/destination';
import { DestinationAPI } from '../../api/DestinationAPI';
import { RawIntegration } from '../../../shared/interfaces/integration';
import { IntegrationsFactory } from '../../../pipelines/factories/integrationFactory';
import { EntityDeleteActionConfirmDialogPropsFactory } from '../../../entity-actions/factory/entityActionsConfirmDialogFactory';

export const DESTINATION_ACTIONS_CONFIRMATION_DIALOG_PROPS: EntityActionConfirmDialogProps<
  DestinationAction,
  Destination
> = {
  [DestinationAction.EDIT]: {},
  [DestinationAction.DELETE]: EntityDeleteActionConfirmDialogPropsFactory<Destination>({
    entity: 'destination',
    affectedEntity: 'pipeline',
    actionResolver: id => DestinationAPI.deleteDestination(id),
    affectedEntityResolver: id => DestinationAPI.getDestinationIntegrations(id),
    affectedEntityFactory: rawData => IntegrationsFactory(rawData as RawIntegration[]),
    postConfirmationParams: 'tab=edge'
  })
};
